import {
  useDataIsSubmitting,
  useDataSubmit,
  useDataValue,
} from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'install' })
  }
}

export function useDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'app',
    viewPath: props.viewPath,
  })
  let acceptedTermsAndConditions = useDataValue({
    context: 'app',
    path: 'acceptedTermsAndConditions',
    viewPath: props.viewPath,
  })

  return isSubmitting || !acceptedTermsAndConditions
}
